/*
 * action types
 */
export const STORE_RESPONSE_IN_ATTEMPTS = 'STORE_RESPONSE_IN_ATTEMPTS'
export const NEXT_QUESTION = 'NEXT_QUESTION'
export const LOAD_DATA = 'LOAD_DATA'
export const CLEAR_DATA = 'CLEAR_DATA'
export const EXIT = 'EXIT'
export const CLEAR_RESPONSES = 'CLEAR_RESPONSES'
export const UPDATE_NAME = 'UPDATE_NAME'
export const START_QUESTION = 'START_QUESTION'
export const UPDATE_CURRENT_QUESTION = 'UPDATE_CURRENT_QUESTION'
export const SET_CURRENT_QUESTION = 'SET_CURRENT_QUESTION'
export const RESUME_PREVIOUS_SESSION = 'RESUME_PREVIOUS_SESSION'
export const SET_LANGUAGE = 'SET_LANGUAGE'

export const SubmitActions = {
  STORE_RESPONSE_IN_ATTEMPTS,
  NEXT_QUESTION,
  LOAD_DATA,
  CLEAR_DATA,
  EXIT,
  CLEAR_RESPONSES,
  UPDATE_NAME,
  START_QUESTION,
  UPDATE_CURRENT_QUESTION,
  SET_CURRENT_QUESTION,
  RESUME_PREVIOUS_SESSION,
  SET_LANGUAGE
}

/*
 * action creators
 */

export function storeResponseInAttempts(response) {
  return { type: STORE_RESPONSE_IN_ATTEMPTS, response}
}

export function clearResponses() {
  return { type: CLEAR_RESPONSES}
}

export function nextQuestion() {
  return { type: NEXT_QUESTION}
}

export function loadData(data) {
  return { type: LOAD_DATA, data}
}

export function clearData(data) {
  return { type: CLEAR_DATA, data}
}

export function exitToHome() {
  return { type: EXIT}
}

export function updateName(data) {
  return { type: UPDATE_NAME, data}
}

export function startQuestion() {
  return {type: START_QUESTION}
}

export function updateCurrentQuestion(data) {
  return { type: UPDATE_CURRENT_QUESTION, data}
}

export function resumePreviousSession(data) {
  return { type: RESUME_PREVIOUS_SESSION, data}
}

export function setCurrentQuestion(data) {
  return { type: SET_CURRENT_QUESTION, data };
}

export function setLanguage(data) {
  return { type: SET_LANGUAGE, data };
}
